import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboard } from "@/projects/admin/pages/DashboardPage";

export const Route = createFileRoute("/admin/")({
  head: () => ({
    meta: [{ title: "Admin Dashboard — રાજનગર જ્ઞાનોત્સવ 2.0" }],
  }),
  component: AdminDashboard,
});
